import { Enumeration } from './Enumeration';

class SplitSalesPolicyStateEnum extends Enumeration {
  Draft = 'draft';
  InForce = 'inForce';

  constructor() {
    super();
    return Object.freeze(this);
  }
}

export const SplitSalesPolicyState = new SplitSalesPolicyStateEnum();
